import React, { useState } from 'react';

const OrderForm = () => {
  const [price, setPrice] = useState(0);
  const [opt, setOpt] = useState('detail');
  const [qnt, setQnt] = useState(1);
  const toggleInputs = (e) => {
    document.querySelector(`#${e.target.value}`).classList.toggle('hidden');

    if (document.querySelector(`#${e.target.value}`).classList.contains('hidden')) {
      setPrice(0);
    }
  };

  const calculatePrice = (option = opt, quantity = qnt) => {
    console.log(option);
    console.log(quantity);
    if (option === 'detail') {
      setPrice(quantity * 1650);
    } else if (option === 'pharmacie') {
      setPrice(quantity * 1370);
    } else if (option === 'grossiste') {
      setPrice(quantity * 1250);
    } else if (option === 'super-grossiste') {
      setPrice(quantity * 1130);
    }
  };

  const changeOption = (e) => {
    setOpt(e.target.value);
    calculatePrice(e.target.value);
  };

  const changeQnt = (e) => {
    setQnt(e.target.value);
    calculatePrice(undefined, e.target.value);
  };

  return (
    <div className="w-full flex flex-col items-center mt-10 md:mt-24 pb-40">
      <h2 className="header">Faites votre commande</h2>
      <form action="https://submit-form.com/RNwKMN2U" method="POST" className="mt-10 md:mt-16 px-8 flex flex-col font-inter">
        <input
          type="hidden"
          name="_redirect"
          value="http://localhost:3000/merci"
        />
        <input type="text" id="name" name="nom" placeholder="Votre nom" required className="input" />
        <input type="tel" id="phone" name="numero de telephone" placeholder="Votre numero de téléphone" required className="input" />
        <input type="text" id="address" name="adresse" placeholder="Votre adresse" required className="input" />
        <hr className="w-40 my-4 border border-gray-700 self-center" />
        <p>Selectionnez les produits que vous voulez commander:</p>
        <div className="mt-6 selectCnt">
          <div>
            <input type="checkbox" id="rhbMed" value="rhb" onChange={toggleInputs} />
            <label htmlFor="rhbMed"> RHB</label>
          </div>
          <div id='rhb' className="hidden">
            <div className="flex items-center">
              <input type="number" name="rhb-quantité" placeholder="Qantité" min="1" className="w-24 p-2 border border-gray-300 rounded mr-4" onChange={changeQnt} />
              <select name="rhb-option" defaultValue="detail" className="p-2 bg-white border border-gray-300 rounded" onChange={changeOption}>
                <option value="detail">Detail</option>
                <option value="pharmacie">Pharmacie</option>
                <option value="grossiste">Grossiste</option>
                <option value="super-grossiste">Super Grossiste</option>
              </select>
            </div>
          </div>

        </div>
        <input type="number" className="hidden" value={price} name="prix" />
        {/* <div className="my-6 selectCnt">
          <div>
            <input type="checkbox" id="sodMed" value="soderma" onChange={handleChange} />
            <label htmlFor="sodMed"> Soderma</label>
          </div>
          <input type="number" name="soderma-quantité" placeholder="Qantité" min="1" id="soderma" className="w-24 p-2 border border-gray-300 rounded hidden" />
        </div>
        <div className="selectCnt">
          <div>
            <input type="checkbox" id="ramixMed" value="ramix" onChange={handleChange} />
            <label htmlFor="ramixMed"> Ramix</label>
          </div>
          <input type="number" name="ramix-quantité" placeholder="Qantité" min="1" id="ramix" className="w-24 p-2 border border-gray-300 rounded hidden" />
        </div> */}

        <p className="my-8 text-lg font-bold">Prix: {price} DA</p>
        <input type="submit" value="Commander" className="submitBtn" />
      </form>
    </div >
  );
};

export default OrderForm;
